const TERMS_VERSIONS = {
	1: 'pdf/Condiciones de uso Signature e Identity_1.pdf',
};

const PRIVACY_VERSIONS = {
	1: 'pdf/Política de privacidad_1.pdf',
};

export const PDFS = {
	TERMS: {
		path: getLatestPdfVersion(TERMS_VERSIONS),
		versions: TERMS_VERSIONS,
	},
	PRIVACY: {
		path: getLatestPdfVersion(PRIVACY_VERSIONS),
		versions: PRIVACY_VERSIONS,
	},
};

function getLatestPdfVersion(versions: { [key: number]: string }): string {
	const versionNumbers = Object.keys(versions).map((key) => parseInt(key, 10));
	const latestVersion = Math.max(...versionNumbers);
	return versions[latestVersion];
}
